import Util from './util';

export default class LanguagePreferences {

	public static getUserLangPrefFromCookie(): string {
		return Util.getCookie('user_pref_language', '').replace(/"/g, '');
	}

	private static _user_pref_language: string = null;
	public static async resolveUserLangPref(): Promise<string> {
		if (!LanguagePreferences._user_pref_language) {
			// langPref query param takes precedence
			const langPref = Util.getQueryParam(window.location.href, 'langPref');
			if (langPref) {
				LanguagePreferences._user_pref_language = Util.getValidLocale(langPref);
			} else {
				if (!(window as any).com || !(window as any).com.TI || !(window as any).com.TI.UserPreferences) await Util.waitUntilGlobalExists('com.TI.UserPreferences.getUserLanguagePreference');
				LanguagePreferences._user_pref_language = await (window as any).com.TI.UserPreferences.getUserLanguagePreference();
			}
		}
		return LanguagePreferences._user_pref_language;
	}

}
